module.exports = __webpack_public_path__ + "static/media/pla_man_cra.faef64be.png";